import { computed, inject, Injectable, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService } from '@ngx-translate/core';
import { EMPTY, map, startWith } from 'rxjs';
import { getLocaleFromLang } from './locale.util';

@Injectable({ providedIn: 'root' })
export class SelectedLanguageLocaleService {
    private readonly translateService = inject(TranslateService);
    private readonly initialLanguage = this.getInitialLanguage();
    private readonly currentLanguage = toSignal(
        (this.translateService.onLangChange ?? EMPTY).pipe(
            map((event) => event.lang),
            startWith(this.initialLanguage)
        ),
        { initialValue: this.initialLanguage }
    );

    public getLocale(fallbackLocale = 'en-US'): Signal<string> {
        return computed(() => getLocaleFromLang(this.currentLanguage(), fallbackLocale));
    }

    private getInitialLanguage(): string {
        return this.translateService.currentLang || this.translateService.getDefaultLang?.() || 'en';
    }
}
